import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../../services/alerts.service';
import { UserService } from '../../../services/user.service';
import { BatchService } from '../../services/batch.service';

/**
 * Component for viewing a workflow batch document process diagram.
 */
@Component({
  selector: 'workflow-batch-document-process-diagram',
  templateUrl: './batch-document-process-diagram.component.html',
  styleUrl: './batch-document-process-diagram.component.css'
})
export class BatchDocumentProcessDiagramComponent implements OnInit {
	@Input() processData: any;

	LOCALIZATION: any;
	
	diagram: SafeHtml = '';
	inprogress: boolean = false;

	constructor(
		private sanitizer: DomSanitizer,
		private modalService: NgbActiveModal,
		private userService: UserService,
		private alertsService: AlertsService,
		private batchService: BatchService			
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loadDiagram(this.processData.processId);
	}
	
	/**
	 * Fetches the workflow process diagram.
	 */
	loadDiagram(pid: number): void {
		this.inprogress = true;
		
		this.batchService.getProcessDiagram(pid).then(
			(svgString: any) => {
				this.diagram = this.sanitizer.bypassSecurityTrustHtml(svgString);
			    this.inprogress = false;
			},
			(err: any) => {
				console.error("Failed loading process diagram", err);
			    this.alertsService.error({
			        message: "Failed to load the process diagram."
			    });
			    this.inprogress = false;
			}
		);		
	}	
	
	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}
}
